import React from 'react';
import {
  IconButton, Tooltip, Select, MenuItem, FormControl, InputLabel, Box
} from '@material-ui/core';
import {
  HourglassFull, Notifications, CompareArrows, Group,
} from '@material-ui/icons';
import { Pagination } from '@material-ui/lab';
import { FaSearch } from 'react-icons/fa';
import PortalCard from 'src/components/insigthFactory/portal/PortalCard';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import EmptyMessage from '@auteco/components/insigthFactory/emptyMessage/EmptyMessage';

import InputSearch from '@auteco/components/insigthFactory/inputSearch/InputSearch';
import PortalSuggestion from '@auteco/components/insigthFactory/portalSugesstion/portalSuggestions';
import wikiInsight from '../../../assets/images/wikiInsightsLogo.png';
import UnitCard from '../../../components/insigthFactory/unitCard/UnitCard';
import {
  Img,
  Button,
  ImgWrapper,
  InputWrapper,
  FormContainer,
  IconsContainer,
  SearchContainer,
  CardContainer,
  useStyles,
} from './styles';
import MultiSelect from '../MultiSelect';
import ReturnButton from '../ReturnButton';

const Portal = (props) => {
  const {
    units,
    posts,
    input,
    onSubmit,
    // errorMsg,
    histories,
    sugerence,
    totalPages,
    clusters,
    filterState,
    selectedClusters,
    permitValue,
    filter,
    onChangePage,
    onChangeInput,
    sugerenceCard,
    onChangeFilter,
    handleClickTest,
    handleClickUsers,
    handleClickEntries,
    handleClickChanges,
    onSearchUnity,
    onSelectClusters,
    onSelectOneCluster,
    onClickReturn
  } = props;
  const classes = useStyles();
  const valueToString = String(posts.length === 0);
  const onlyItems = sugerenceCard?.slice(0, 6);
  return (
    <>
      <CardTitle title="Historias de usuario" />
      {filter && <ReturnButton label='Volver' onClick={onClickReturn} />}
      {/* Logo */}
      <CardContainer primary={valueToString}>
        <SearchContainer primary={valueToString}>
          <IconsContainer>
            {permitValue === 5 ? (
              <>
                <IconButton onClick={handleClickEntries}>
                  <Tooltip title="Entradas Nuevas">
                    <Notifications />
                  </Tooltip>
                </IconButton>
                <IconButton onClick={handleClickUsers}>
                  <Tooltip title="Gestion de usuarios">
                    <Group />
                  </Tooltip>
                </IconButton>
              </>
            ) : null}
            {permitValue >= 4 ? (
              <>
                <IconButton onClick={handleClickTest}>
                  <Tooltip title="Resultados por Aceptar">
                    <HourglassFull />
                  </Tooltip>
                </IconButton>
                <IconButton onClick={handleClickChanges}>
                  <Tooltip title="Aprobar Cambios en Insights">
                    <CompareArrows />
                  </Tooltip>
                </IconButton>
              </>
            ) : null}
          </IconsContainer>
          {posts.length === 0 ? (
            <ImgWrapper>
              <Img src={wikiInsight} alt="logo" />
            </ImgWrapper>
          ) : null}
          <div style={{ display: 'flex', alignItems: 'center', minWidth: '700px', margin: (posts.length === 0 && (filter || !filter)) ? '0 60px 60px' : '0 auto', justifyContent: (posts.length === 0 && (filter || !filter)) && 'space-between' }}>
            <FormContainer
              component="form"
              onSubmit={onSubmit}
              primary={valueToString}
            >
              <InputWrapper primary={valueToString}>
                <InputSearch
                  sugerence={sugerence}
                  onChangeInput={onChangeInput}
                  placeholder='Buscar por historia'
                  value={input}
                  style={{ minWidth: valueToString && '200px', width: (posts.length === 0 && (filter || !filter)) && '300px' }}
                />
                <Button primary={valueToString} type="submit" disabled={!input}>
                  {/* {posts.length > 0 ? <FaSearch /> : 'Buscar Historia'} */}
                  <FaSearch />
                </Button>
              </InputWrapper>
            </FormContainer>
            <MultiSelect
              options={clusters}
              label='Filtrar por cluster'
              style={{ width: (posts.length === 0 && (filter || !filter)) ? null : '600px' }}
              selected={selectedClusters}
              handleChange={onSelectClusters}
              handleSelectOne={onSelectOneCluster}
            />
            <Box style={{ marginLeft: '20px' }}>
              <FormControl>
                <InputLabel htmlFor="socio-native-simple" style={{ marginLeft: '10px' }}>
                  Buscar por unidad
                </InputLabel>
                <Select
                  value={filterState}
                  placeholder='Filtrar unidad'
                  onChange={(e) => onChangeFilter(e)}
                  style={{ width: '260px', marginRight: '10px' }}
                  inputProps={{
                    name: 'estado',
                    id: 'socio-native-simple',
                  }}
                  variant='outlined'
                >
                  <MenuItem value="">Ninguno</MenuItem>
                  {units.map((unit, index) => (
                    <MenuItem key={unit.id} value={index}>
                      {unit.unidad}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </div>
          {/* {errorMsg ? (
            <Typography className={classes.errorMsg}>{errorMsg}</Typography>
          ) : null} */}
        </SearchContainer>

        {posts.length === 0 && !filter ? (
          <Box className={classes.containerCard}>
            <Box className={classes.cards}>
              {units.map((unit, index) => (
                <UnitCard
                  unit={unit}
                  key={unit.id}
                  onSearchUnity={() => onSearchUnity(index)}
                />
              ))}
            </Box>
            <div className={classes.break} />
            <Box className={classes.cards}>
              {onlyItems?.map((sgce) => (
                <PortalSuggestion key={sgce.id} sugerence={sgce} />
              ))}
            </Box>
          </Box>
        ) : null}
      </CardContainer >

      {
        (posts.length > 0 || filter) ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: '10px',
            }}
          >
            {(histories.length === 0 || (histories.length === 0 && filter)) ? (
              <EmptyMessage title="No hay historias con esta unidad de negocio o cluster" />
            ) : null}

            {histories.map((history) => (
              <PortalCard history={history} key={history.id} />
            ))}
            {totalPages ? (
              <Pagination count={totalPages} onChange={onChangePage} />
            ) : null}
          </div>
        ) : null
      }
    </>
  );
};

export default Portal;
